import { MapPin, Search, X } from 'react-feather';
import Paragraph from '../../Typography/Paragraph';
import MultiSelectFullPill from '../../Fields/MultiSelect/Full/Pill';
var CardBookmark = function (_a) {
    var _b;
    var bookmark = _a.bookmark, onDelete = _a.onDelete;
    return (<div className="flex flex-col gap-4 rounded-lg border border-gray-300 p-4">
      <div className="flex justify-between gap-4">
        <a href={bookmark.link}>
          <Paragraph>{bookmark.title}</Paragraph>
        </a>
        <X size={24} className="cursor-pointer" onClick={function () { return onDelete(bookmark.id); }}/>
      </div>
      {bookmark.name && (<div className="flex items-center gap-2">
          <Search size={16}/>
          <Paragraph size="xs">{bookmark.name}</Paragraph>
        </div>)}
      {bookmark.location && (<div className="flex items-center gap-2">
          <MapPin size={16}/>
          <Paragraph size="xs">
            {bookmark.location}
            {bookmark.radius && ' - ' + bookmark.radius + ' km'}
          </Paragraph>
        </div>)}
      {((_b = bookmark.filters) === null || _b === void 0 ? void 0 : _b.length) ? (<div className="flex flex-wrap gap-4">
          {bookmark.filters.map(function (filter) {
                return (<MultiSelectFullPill item={filter} onClick={function () { }} selected disabled={false} key={filter.id}/>);
            })}
        </div>) : null}
    </div>);
};
export default CardBookmark;
